import React from "react";
import { Grid, Paper } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const CallInfoSkeleton = () => {
  return (
     < >
      <Grid container spacing={2}>

         <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Skeleton variant="rect" width={160} height={50} style={{ marginRight: 8 }} />
          <Skeleton variant="rect" width={160} height={50} />
        </Grid>

        {/* Date */}
        <Grid item xs={12} sm={6} md={3}>
          <Skeleton variant="text" width="90%" height={60} />
        </Grid>

        {/* Type */}
        <Grid item xs={12} sm={6} md={3}>
          <Skeleton variant="text" width="90%" height={60} />
        </Grid>

        {/* Payor */}
        <Grid item xs={12} sm={6} md={3}>
          <Skeleton variant="text" width="90%" height={60} />
        </Grid>

        {/* Portal */}
        <Grid item xs={12} sm={6} md={3}>
          <Skeleton variant="text" width="90%" height={60} />
        </Grid>

        {/* Copay/Coinsurance */}
        <Grid item xs={12} sm={6} md={3}>
          <Skeleton variant="text" width="90%" height={60} />
        </Grid>

        {/* Copay Value */}
        <Grid item xs={12} sm={6} md={3}>
          <Skeleton variant="text" width="90%" height={60} />
        </Grid>

        {/* Outstanding Deductible */}
        <Grid item xs={12} sm={6} md={3}>
          <Skeleton variant="text" width="90%" height={60} />
        </Grid>

        {/* Patient Balance */}
        <Grid item xs={12} sm={6} md={3}>
          <Skeleton variant="text" width="90%" height={60} />
        </Grid>

        {/* Actions */}
        <Grid item xs={12} sm={6} md={3}>
          <Skeleton variant="text" width="90%" height={60} />
        </Grid>

        {/* Result */}
        <Grid item xs={12} sm={6} md={3}>
          <Skeleton variant="text" width="80%" height={60} />
        </Grid>

        {/* Notes */}
        <Grid item xs={12}>
          <Skeleton variant="rect" width="100%" height={60} />
        </Grid>
       
      </Grid>
    </>
  )
}

export default CallInfoSkeleton